import dispatcher from '../dispatcher';

var elementProto = Object.create(HTMLElement.prototype);
var lang;

var loadAPI = function() {
	return new Promise((resolve, reject) => {
		if (typeof ymaps3 !== 'undefined') {
            resolve();
            return;
        }
		
        const script = document.createElement('script');
        script.src = 'https://api-maps.yandex.ru/v3/?apikey=180151ce-a4fc-4fc1-87e4-02c7c3eec3aa&lang=ru_RU';
		script.async = true;
		script.onload = () => {
            resolve();
        };
		script.onerror = () => {
            reject(new Error('Failed to load Yandex Maps API'));
        };
        document.head.appendChild(script);
    });
}

var _addMarker = function(coordinates) {
	var marker;
	var self = this;
	var map = this._map;
	var markerElement = self._marker;

	marker = new ymaps3.YMapMarker(
		{
		  coordinates: coordinates,
		  draggable: false,
		  disableRoundCoordinates: true,
		},
		markerElement,
	);

	map.addChild(marker);
}

var _build = function() {
	var lat, lng, zoom;
	var id;
	var config, styles;
	var self = this;

	if (this._ready) return;
	this._ready = true;

	id =   this.id;
	lat  = this.getAttribute('data-lat')  || 0;
	lng  = this.getAttribute('data-lng')  || 0;
	zoom = parseInt(this.getAttribute('data-zoom')) || 2;

	styles = [{"stylers":[{"saturation":0},{"hue":"#e7ecf0"}]},{"tags":{"all":"road"},"stylers":[{"saturation":-0.7}]},{"tags":{"all":"transit"},"stylers":[{"visibility":"off"}]},{"tags":{"all":"poi"},"stylers":[{"visibility":"off"}]},{"tags":{"all":"water"},"stylers":[{"saturation":-0.6}]}];

	config = {
		location: {
			center: [Number(lng), Number(lat)],
			zoom: Number(zoom),
		}
	}

	const map = new ymaps3.YMap(this._container, config);

	const layer = new ymaps3.YMapDefaultSchemeLayer({
		customization: styles
	});
	map.addChild(layer);
	map.addChild(new ymaps3.YMapDefaultFeaturesLayer({ zIndex: 1800 }));

	this._map = map;
	this._container.style.background = '#dfdfdf';
}

var _handleDispatcher = function(e) {
	if (e.type === 'map:move') {
		if (!this._map) return;

		this._addMarker([e.lng, e.lat])
		this._map.setLocation({ center: [e.lng, e.lat] });
	}
}

elementProto.createdCallback = function() {
	this.build = _build.bind(this);
	this._addMarker = _addMarker.bind(this);
	this.handleDispatcher = _handleDispatcher.bind(this);
	this.addMarker = _addMarker.bind(this);
}
elementProto.attachedCallback = function() {
	var html = document.getElementsByTagName('html')[0];
	this._marker = this.getElementsByClassName('map-marker')[0];
	this._container = this.getElementsByClassName('map-container')[0];

	lang = html.getAttribute('lang');

	dispatcher.subscribe(this.handleDispatcher);

	if (!lang) lang = 'ru';

	loadAPI().then(() => {
		ymaps3.ready.then(() => {
			this.build();
		});
	}).catch(error => {
		console.error('Error loading Yandex Maps API:', error);
	});
}
elementProto.detachedCallback = function() {
	dispatcher.unsubscribe(this.handleDispatcher);
}

document.registerElement('map-component', {
	prototype: elementProto
});